export default __webpack_public_path__ + "static/media/9.bc4bd425.jpg";